/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import React from "react";
import { connect, ConnectedProps, useDispatch } from "react-redux";
import { css } from "styled-components";

type Props = ConnectedProps<typeof connector>;

export interface ProductListFiltersButtonStyles {
    buttonStyle?: ButtonPresentationProps;
}

export const productListFiltersButtonStyles: ProductListFiltersButtonStyles = {
    buttonStyle: {
        icon: { position: "left", src: "Sliders" },
        css: css`
            @media (max-width: 768px) {
                width: 100%;
                justify-content: center;
            }
            @media (max-width: 481px) {
                margin-bottom: 16px;
            }
            & svg {
                transform: rotate(90deg);
            }
        `,
    },
};

const styles = productListFiltersButtonStyles;

const ProductListFiltersButton: React.FC<Props> = () => {
    const dispatch = useDispatch();

    return (
        <Button
            {...styles.buttonStyle}
            onClick={() => {
                dispatch({ type: "xProductList/isFiltersDrawerOpen", isFiltersDrawerOpen: true });
            }}
        >
            {translate("Filter Results")}
        </Button>
    );
};

const connector = connect();

export default connector(ProductListFiltersButton);
